import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isOnlineServicesMenuEnabled, setIsOnlineServicesMenuEnabled] = useState(true);

  useEffect(() => {
    setMobileMenuOpen(false);
    const token = localStorage.getItem('uid');
    const userStr = localStorage.getItem('user');
    setIsLoggedIn(!!token);
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setIsAdmin(user.role === 'ADMIN');
      } catch (e) {
        setIsAdmin(false);
      }
    }

    // Fetch settings to check if Online Services menu should be displayed
    fetch(`${process.env.REACT_APP_BACKEND_URL || ''}/api/settings`)
      .then(res => res.json())
      .then(data => {
        if (data && data.status === 'success' && data.data) {
          setIsOnlineServicesMenuEnabled(data.data.is_online_services_menu_enabled !== false);
        }
      })
      .catch(err => console.error("Error fetching settings for header:", err));
  }, [location]);

  const handleSubmenu = (e) => {
    e.preventDefault();
    const parent = e.currentTarget.closest('li');
    if (!parent) return;
    parent.classList.toggle('th-active');
    const submenu = parent.querySelector('.sub-menu');
    if (submenu) submenu.classList.toggle('th-open');
  };

  const closeMobile = () => setMobileMenuOpen(false);

  const handleLogout = () => {
    localStorage.removeItem('uid');
    localStorage.removeItem('user');
    setIsLoggedIn(false);
    navigate('/');
    window.location.reload();
  };

  useEffect(() => {
    const btn = document.getElementById('mobile-logout-btn');
    const onLogoutClick = (e) => {
      e.preventDefault();
      handleLogout();
      closeMobile();
    };
    if (btn) {
      btn.addEventListener('click', onLogoutClick);
      return () => btn.removeEventListener('click', onLogoutClick);
    }
  }, [isLoggedIn]);

  return (
    <>
      <div className={`th-menu-wrapper ${mobileMenuOpen ? 'th-body-visible' : ''}`}>
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={() => setMobileMenuOpen(false)}>
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="/" onClick={closeMobile}>
              <img src="/web/assets/img/logoji.svg" alt="Hariharapura" />
            </Link>
          </div>
          <div className="th-mobile-menu">
            <ul>
              {/* <li><Link to="/test" onClick={closeMobile}>Test</Link></li> */}
              <li><Link to="/" onClick={closeMobile}>Home</Link></li>
              <li><Link to="/about" onClick={closeMobile}>About</Link></li>
              <li className="menu-item-has-children">
                <a href="#!" onClick={handleSubmenu}>Events</a>
                <ul className="sub-menu th-submenu">
                  <li><Link to="/events" onClick={closeMobile}>Past Events</Link></li>
                  <li><Link to="/upcoming-events" onClick={closeMobile}>Upcoming Events</Link></li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <a href="#!" onClick={handleSubmenu}>Activities</a>
                <ul className="sub-menu th-submenu">
                  <li><Link to="/yearly-activities" onClick={closeMobile}>Yearly Activities</Link></li>
                  <li><Link to="/social-activities" onClick={closeMobile}>Social Activities</Link></li>
                  <li><Link to="/services" onClick={closeMobile}>Services</Link></li>
                </ul>
              </li>
              {/* <li><Link to="/publications" onClick={closeMobile}>Publications</Link></li> */}
              {isOnlineServicesMenuEnabled && (
                <li><Link to="/booking-seva" onClick={closeMobile}>Online Services</Link></li>
              )}


              <li><Link to="/contact" onClick={closeMobile}>Contact Us</Link></li>
              {isAdmin && (
                <li><Link to="/admin/payments" onClick={closeMobile}>Admin Payments</Link></li>
              )}

              {isLoggedIn ? (
                <li className="menu-item-has-children">
                  <a href="#!" onClick={handleSubmenu}>Profile</a>
                  <ul className="sub-menu th-submenu">
                    <li><Link to="/profile" onClick={closeMobile}>My Profile</Link></li>
                    <li>
                      <a id="mobile-logout-btn" href="#!" style={{ cursor: 'pointer' }}>Logout</a>
                    </li>
                  </ul>
                </li>
              ) : (
                <li>
                  <Link to="/login" onClick={closeMobile} style={{ marginLeft: '20px', color: 'inherit' }}>Login</Link>
                </li>
              )}

            </ul>
          </div>
        </div>
      </div>

      <header className="th-header header-layout5">
        <div className="header-top">
          <div className="container">
            <div className="row justify-content-center justify-content-md-between align-items-center gy-2">
              <div className="col-auto d-none d-md-block">
                <div className="header-links">
                  <ul>
                    <li>
                      <i className="far fa-phone"></i>
                      <a href="tel:9019977466">(+91) 901 997 7466</a>
                    </li>
                    <li>
                      <i className="far fa-envelope"></i>
                      <a href="mailto:hhpuraoff@gmail.com">hhpuraoff@gmail.com</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-auto">
                <div className="header-links">
                  <ul>
                    <li>
                      <div className="header-social">
                        <span className="social-title">Follow Us:</span>
                        <a href="https://www.facebook.com/share/17YvF8L42f/" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
                        <a href="https://whatsapp.com/channel/0029Vb5hOsPId7nDh5SDJO1Z" target="_blank" rel="noreferrer"><i className="fab fa-whatsapp"></i></a>
                        <a href="https://youtube.com/@hariharapurmath?si=4tvE7Xxv87cdcoHx" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
                        <a href="https://www.instagram.com/hariharapurmath?igsh=c2Z1d2pod2d6b2w2" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky-wrapper">
          <div className="menu-area" data-bg-src="/assets/img/bg/pattern_bg_2.html">
            <div className="container">
              <div className="row align-items-center justify-content-between flex-nowrap">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img src="/web/assets/img/logoji.svg" alt="Hariharapura" />
                    </Link>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <nav className="main-menu d-none d-xxl-inline-block">
                        <ul>
                          <li><Link to="/">Home</Link></li>
                          <li><Link to="/about">About</Link></li>
                          <li className="menu-item-has-children">
                            <a href="#!">Events</a>
                            <ul className="sub-menu">
                              <li><Link to="/events">Past Events</Link></li>
                              <li><Link to="/upcoming-events">Upcoming Events</Link></li>
                            </ul>
                          </li>
                          <li className="menu-item-has-children">
                            <a href="#!">Activities</a>
                            <ul className="sub-menu">
                              <li><Link to="/yearly-activities">Yearly Activities</Link></li>
                              <li><Link to="/social-activities">Social Activities</Link></li>
                              <li><Link to="/services">Services</Link></li>
                            </ul>
                          </li>
                          {/* <li><Link to="/publications">Publications</Link></li> */}
                          {isOnlineServicesMenuEnabled && (
                            <li><Link to="/booking-seva">Online Services</Link></li>
                          )}

                          <li><Link to="/contact">Contact Us</Link></li>

                          {isAdmin && (
                            <>
                              <li><Link to="/admin/payments">Admin Payments</Link></li>
                              <li><Link to="/admin/settings">Settings</Link></li>
                            </>
                          )}

                          {/* Desktop Icon Button */}
                          {isLoggedIn ? (
                            <li className="menu-item-has-children">
                              <a href="#!">Profile</a>
                              <ul className="sub-menu">
                                <li><Link to="/profile">My Profile</Link></li>
                                <li>
                                  <Link to="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>Logout</Link>
                                </li>
                              </ul>
                            </li>
                          ) : (
                            <li><Link to="/login">Login</Link></li>
                          )}
                        </ul>
                      </nav>
                      <button
                        type="button"
                        className="th-menu-toggle d-inline-block d-xxl-none"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                      >
                        <i className="far fa-bars"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="logo-shape"></div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
